import {EntityStateAdapter} from '@/store/base.store';
import {ChallengeModel} from '@/models/challenge.model';
import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {UserApi} from '@/api/user.api';
import {take} from 'rxjs/operators';

export const featureKey = 'followed_challenges';

// @ts-ignore
if (store.state.followed_challenges) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class FollowedChallengesStoreModule extends EntityStateAdapter<ChallengeModel> {

  get followedChallenges(): ChallengeModel[] {
    return this._entities
  }

  get isFollowing(): (challengeId: number) => boolean {
    return (challengeId: number) => {
      return !!this._entities?.find((v) => v.id === challengeId);
    }
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchfollowedChallenges(slug: string): Promise<ChallengeModel[]> {
    this.updateLoading(true);
    const res = await (new UserApi()).getSubscriptions(slug).pipe(take(1)).toPromise();
    this.context.commit('updateAllPageParams', res);
    return res.data;
  }

  @Action({commit: 'insertOne', rawError: true})
  addFollowedChallenge(challenge: ChallengeModel): ChallengeModel {
    return challenge;
  }

  @Action({commit: 'insertOne', rawError: true})
  async follow(challenge: ChallengeModel): Promise<any> {
    if (!challenge.id) {
      return
    }
    this.updateLoading(true);
    await (new UserApi()).follow(challenge.id).pipe(take(1)).toPromise();
    return challenge;
  }

  @Action({commit: 'removeOne', rawError: true})
  async unfollow(id: number): Promise<number> {
    this.updateLoading(true);
    await (new UserApi()).unfollow(id).pipe(take(1)).toPromise();
    return id
  }

}
